import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Divider, Card, Button } from 'antd'
import { CloseCircleOutlined, DeleteFilled } from '@ant-design/icons'
import DeviceCard from './deivce.card'
import _ from 'lodash'
import '../../css/patient.scss'
import { assignDevices } from '../../store/action/device.action'
import serviceInterface from '../../services/service.interface'
import { EditOutlined } from '@ant-design/icons'
import { useLocation } from 'react-router'
import moment from 'moment'
import AddDevice from './device.select'
import { Modal, Checkbox, List } from 'antd'

const AssignedDevices = (props) => {
  const location = useLocation()
  const patient = location.state?.patient

  var handleRemoveClick = (e, id) => {
    e.stopPropagation()
    var devices = serviceInterface
      .DeviceService()
      .removeDevice(id, props.assignedDevices)

    props.assignDevices(devices)
  }

  var renderDevices = () => {
    var devices = props.assignedDevices ? props.assignedDevices : []
    console.log('Assigned DEvices', devices)
    return devices?.map((dev, i) => {
      return (
        <Row className={'regimenRow'}>
          <Col style={{ width: '100%' }}>
            <Row>
              <Col>
                <Row className='regHeader'>{dev?.display_name}</Row>
                <Row className='descp'></Row>
              </Col>
              <Col className='removeIcon'>
                <DeleteFilled onClick={(e) => handleRemoveClick(e, dev?._id)} />
              </Col>
            </Row>
          </Col>
        </Row>
      )
    })
  }
  return (
    <Col className='assignedContainer'>
      <Row className='selectorContainer'>
        <Col style={{ width: '100%' }}>
          <Row className='header'>
            <Col style={{ width: '100%' }}>
              <Row>ASSIGNED PLAN</Row>
              <Row className='descp'>
                <Col>PATIENT </Col>
                <Col style={{ marginLeft: 'auto' }}>
                  {patient?.firstname + ' ' + patient?.lastname}
                </Col>
              </Row>
              <Row className='descp'>
                <Col>SURGERY DATE</Col>
                <Col style={{ marginLeft: 'auto' }}>
                  {moment(patient?.surgery?.date).format('MM/DD/YYYY')}
                </Col>
              </Row>

              <Row className='descp'>
                <Col>PLAN SELECTED</Col>
                <Col style={{ marginLeft: 'auto' }}>
                  {props.plan?.name ? props.plan?.name : 'NOT SELECTED'}
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          {props.assignedDevices?.length > 0 && (
            <>
              <Row className='descp'>DEVICES</Row>{' '}
              <Card
                bordered={false}
                className='assignedCard'
                style={{ height: 'auto' }}
              >
                {renderDevices()}
              </Card>
            </>
          )}
          <Col style={{ display: 'flex', justifyContent: 'center' }}>
            {props.plan?.name && (
              <AddDevice
                assignedDevices={props.assignedDevices}
                devices={props.devices}
                assignDevices={props.assignDevices}
                surgeryDate={location.state?.patient?.surgery?.date}
              />
            )}
          </Col>
        </Col>
      </Row>
    </Col>
  )
}

AssignedDevices.propTypes = {
  company: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    assignedDevices: state.device.assignedDevices,
    plan: state.device.assignedPlan,
    devices: state.device.devices,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    assignDevices: (devices) => dispatch(assignDevices(devices)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignedDevices)
